{
  "NLAMS" : [
    {
      "name" : "PTA",
      "portAuthorityId" : "PTA"
    },
    {
      "name" : "Wagenborg Sleepdienst BV",
      "portAuthorityId" : "WAGENBORGSLEEP"
    }
  ],
  "NLDZL" : [
    {
      "name" : "Int. Sleepdienst BIJMA",
      "portAuthorityId" : "BIJMA"
    },
    {
      "name" : "Port Towage Groningen",
      "portAuthorityId" : "P.T.G."
    },
    {
      "name" : "Wagenborg Sleepdienst BV",
      "portAuthorityId" : "WAGENS"
    }
  ],
  "NLHAR" : [
    {
      "name" : "A. Tuinman & Zn.",
      "portAuthorityId" : "TUINTOW"
    }
  ],
  "NLRTM" : [
    {
      "name" : "Boluda",
      "portAuthorityId" : "BOLUDA"
    },
    {
      "name" : "Sleepboten voor verpl. in Dok",
      "portAuthorityId" : "DOKBOTEN"
    },
    {
      "name" : "Fairplay",
      "portAuthorityId" : "FAIRPLAY"
    },
    {
      "name" : "Sleepdienst Geen Voorkeur",
      "portAuthorityId" : "GEEN"
    },
    {
      "name" : "Gepke",
      "portAuthorityId" : "GEPKE"
    },
    {
      "name" : "HEBO",
      "portAuthorityId" : "HEBO"
    },
    {
      "name" : "Lekstroom",
      "portAuthorityId" : "LEKSTROOM"
    },
    {
      "name" : "Limburgia",
      "portAuthorityId" : "LIMBURGIA"
    },
    {
      "name" : "MEDTUG",
      "portAuthorityId" : "MEDTUG"
    },
    {
      "name" : "Muller",
      "portAuthorityId" : "MULLER DORDRECHT"
    },
    {
      "name" : "Multraship Towage & Salvage",
      "portAuthorityId" : "MULTRATUG"
    },
    {
      "name" : "Niet Benoemde Sleepdienst",
      "portAuthorityId" : "OVERIGE"
    },
    {
      "name" : "Stemat",
      "portAuthorityId" : "STEMAT"
    },
    {
      "name" : "Svitzer",
      "portAuthorityId" : "SVW"
    },
    {
      "name" : "VKV Service B.V.",
      "portAuthorityId" : "VKV"
    },
    {
      "name" : "Van Der Wees",
      "portAuthorityId" : "WEES VAN DER"
    },
    {
      "name" : "Van Wijngaarden",
      "portAuthorityId" : "WIJNGAARDEN"
    }
  ],
  "NLSCE" : [
    {
      "name" : "Iskes Towage & Salvage",
      "portAuthorityId" : "ISKES"
    },
    {
      "name" : "Havensleepdienst Scheveningen BV",
      "portAuthorityId" : "SLS"
    }
  ],
  "NLTNZ": [
    {
      "name": "Scheldt Maritime Services",
      "portAuthorityId" : "SMS"
    },
    {
      "name": "Boluda",
      "portAuthorityId" : "SMIT"
    }
  ],
  "NLVLI": [
    {
      "name": "Scheldt Maritime Services",
      "portAuthorityId" : "SMS"
    },
    {
      "name": "Boluda",
      "portAuthorityId" : "SMIT"
    }
  ]
}
